import { render, staticRenderFns } from "./PlanMovil.vue?vue&type=template&id=6ffea5d5&scoped=true"
import script from "./PlanMovil.vue?vue&type=script&lang=js"
export * from "./PlanMovil.vue?vue&type=script&lang=js"
import style0 from "./PlanMovil.vue?vue&type=style&index=0&id=6ffea5d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffea5d5",
  null
  
)

export default component.exports